<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 mb-4">Добро пожаловать в WikiBase</h1>
        <p class="text-body-1">
          Корпоративная база знаний с интеграцией Telegram и LLM-ассистентом
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>
            <v-icon start>mdi-note-text</v-icon>
            Заметки
          </v-card-title>
          <v-card-text>
            Создавайте и управляйте заметками в базе знаний
          </v-card-text>
          <v-card-actions>
            <v-btn to="/notes" color="primary">
              Перейти к заметкам
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>
            <v-icon start>mdi-telegram</v-icon>
            Telegram
          </v-card-title>
          <v-card-text>
            Интеграция с Telegram для автоматического сбора информации
          </v-card-text>
          <v-card-actions>
            <v-btn to="/telegram" color="primary">
              Настройки Telegram
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>
            <v-icon start>mdi-robot</v-icon>
            LLM Ассистент
          </v-card-title>
          <v-card-text>
            Искусственный интеллект для поиска и анализа информации
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="openChat">
              Открыть чат
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Статистика</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <div class="text-center">
                  <div class="text-h4">{{ stats.notes || 0 }}</div>
                  <div class="text-caption">Заметок</div>
                </div>
              </v-col>
              <v-col cols="3">
                <div class="text-center">
                  <div class="text-h4">{{ stats.tags || 0 }}</div>
                  <div class="text-caption">Тегов</div>
                </div>
              </v-col>
              <v-col cols="3">
                <div class="text-center">
                  <div class="text-h4">{{ stats.users || 0 }}</div>
                  <div class="text-caption">Пользователей</div>
                </div>
              </v-col>
              <v-col cols="3">
                <div class="text-center">
                  <div class="text-h4">{{ stats.telegramChats || 0 }}</div>
                  <div class="text-caption">Telegram чатов</div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Чат с LLM -->
    <v-dialog v-model="chatDialog" max-width="600">
      <v-card>
        <v-card-title>
          Чат с LLM Ассистентом
          <v-spacer></v-spacer>
          <v-btn icon @click="chatDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="chatMessage"
            label="Ваш вопрос"
            rows="3"
            placeholder="Задайте вопрос о проекте или попросите найти информацию..."
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="sendMessage" color="primary" :loading="loading">
            Отправить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
// @ts-nocheck
import { ref, onMounted } from 'vue'
import { useApiStore } from '@/stores/api'

const chatDialog = ref(false)
const chatMessage = ref('')
const loading = ref(false)
const stats = ref({
  notes: 0,
  tags: 0,
  users: 0,
  telegramChats: 0
})

const openChat = () => {
  chatDialog.value = true
}

const sendMessage = async () => {
  if (!chatMessage.value.trim()) return
  
  loading.value = true
  try {
    const apiStore = useApiStore()
    const result = await apiStore.searchKnowledgeBase(chatMessage.value)
    
    // Показываем результат в диалоге
    alert(`Ответ LLM: ${result.answer}`)
  } catch (error) {
    console.error('Error sending message:', error)
    alert('Ошибка при отправке сообщения')
  } finally {
    loading.value = false
    chatMessage.value = ''
    chatDialog.value = false
  }
}

onMounted(() => {
  // TODO: Загрузить статистику
})
</script>
